import React, { useEffect, useState } from "react";
// import "../styles/LandingPage.css";
import BannerIllu from "../Assets/bannerIllu.png";
import { FaTwitter } from "react-icons/fa";
import StaciaTextLogo from "../Assets/staciaTextLogo.png";
import { useNavigate } from "react-router-dom";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import "../Styles/LandingPage.css";
import FormHeroImg from "../Assets/formLandingHeroImg.png";
import { FaCheck } from "react-icons/fa6";
import LandingGridImg1 from "../Assets/landing/landigngridimg1.png";
import LandingGridImg2 from "../Assets/landing/landigngridimg2.png";
import LandingGridImg3 from "../Assets/landing/landigngridimg3.png";
import LandingGridImg4 from "../Assets/landing/landigngridimg4.png";
import GetStart from "../Assets/landing/landingGetStartedIcon.png";
import LandingCube from "../Assets/landing/designedCube.png";

const testimonialData = [
  {
    name: "Carter Gouse",
    email: "example@mail.com",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem nihil consequuntur alias optio labore aspernatur veritatis, blanditiis dicta quas necessitatibus voluptatibus cum odit fugiat porro! Laborum architecto iusto similique minima nulla incidunt vel tempore sapiente dolore voluptate voluptatem perferendis laboriosam fuga nemo adipisci, ab obcaecati? Praesentium dolor neque amet repellendus.",
  },
  {
    name: "Carter Gouse",
    email: "example@mail.com",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem nihil consequuntur alias optio labore aspernatur veritatis, blanditiis dicta quas necessitatibus ",
  },
  {
    name: "Carter Gouse",
    email: "example@mail.com",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem nihil consequuntur alias optio labore aspernatur veritatis, blanditiis dicta quas necessitatibus voluptatibus cum odit fugiat porro! Laborum architecto iusto sim",
  },
  {
    name: "Carter Gouse",
    email: "example@mail.com",
    desc: "Lorem ipsum dolor sit amet constatibus cum odit fugiat porro! Laborum architecto iusto similique minima nulla incidunt vel tempore sapiente dolore voluptate voluptatem perferendis laboriosam fuga nemo adipisci, ab obcaecati? Praesentium dolor neque amet repellendus.",
  },
  {
    name: "Carter Gouse",
    email: "example@mail.com",
    desc: "Lorem ipsum dolor sit amet consectetur ae sapiente dolore voluptate voluptatem perferendis laboriosam fuga nemo adipisci, ab obcaecati? Praesentium dolor neque amet repellendus.",
  },
  {
    name: "Carter Gouse",
    email: "example@mail.com",
    desc: "Lorem insequuntur alias optio labore aspernatur veritatis, blanditiis dicta quas necessitatibus voluptatibus cum odit fugiat porro! Laborum architecto iusto similique minima nulla incidunt vel tempore sapiente dolore voluptate voluptatem perferendis laboriosam fuga nemo adipisci, ab obcaecati? Praesentium dolor neque amet repellendus.",
  },
  {
    name: "Carter Gouse",
    email: "example@mail.com",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem nihil consequuntur alias optio labore aspernatur veritatis, blanditiis dicta quas necessitatibus voluptatibus cum odit fugiat porro! Laborum architecto iusto similique minima nulla incidunt vel tempore sapiente dolore voluptate voluptatem perferendis laboriosam fuga nemo adipisci, ab obcaecati? Praesentium dolor neque amet repellendus.",
  },
  {
    name: "Carter Gouse",
    email: "example@mail.com",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing eli cum odit fugiat porro! Laborum architecto iusto similique minima nulla incidunt vel tempore sapiente dolore voluptate voluptatem perferendis laboriosam fuga nemo adipisci, ab obcaecati? Praesentium dolor neque amet repellendus.",
  },
  {
    name: "Carter Gouse",
    email: "example@mail.com",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem nihil consequuntur alias optio labore aspernatur veritatis, blanditiis dicta quas necessitatibus voluptatibus cum odit fugiat porro! Laborum architecto iusto similique minima nulla incidunt vel tempore sapiente dolore voluptate voluptatem perferendis laboriosam fuga nemo adipisci, ab obcaecati? Praesentium dolor neque amet repellendus.",
  },
];

function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="landingContainer">
      <div className="top-gred-container"></div>

      <div className="landingTopbar">
        <div
          style={{
            width: "33%",
            display: "flex",
            alignItems: "baseline",
            gap: "0.5rem",
          }}
        >
          <div>
            <img src={StaciaTextLogo} alt="" />
          </div>
          <div
            style={{
              fontFamily: "EuclidSemibold",
              fontSize: "28px",
              color: "#1B51BB",
              letterSpacing: "1.5px",
            }}
          >
            FORMS
          </div>
        </div>
        {/* <div className="landing-top-bar-options center-opts">
          <div>Enterprise</div>
          <div>Pricing</div>
          <div>FAQ</div>
        </div> */}
        <div className="landing-top-bar-options">
          {/* <div className="signInBtn" onClick={() => navigate("/signIn")}>
            Sign in
          </div> */}
          <div className="GetStartedBtn" onClick={() => navigate("/register")}>
            Get started
          </div>
        </div>
      </div>
      <div className="landing-content">
        <div>
          <div className="hero-heading">
            Efficient form creation with a <br /> powerful form builder
          </div>
          <div className="landing-hero-desc">
            Savings, visiblility and infrastructure guardrails. <br />
            One automated platform
          </div>
          <div
            className="hero-getstarted-btn"
            onClick={() => navigate("/register")}
          >
            <div>
              {" "}
              <img src={GetStart} width={"100%"} alt="" />{" "}
            </div>
            <div>Get Started for free</div>
          </div>
          <div className="landing-hero-img-container">
            <div>
              <img src={FormHeroImg} alt="" />
            </div>
          </div>
        </div>
        <div style={{ marginTop: "3rem" }}>
          <div className="landing-section2-title">
            Antimetal is a complete command <br /> and control system for AWS
          </div>
          <div className="landing-section2-desc">
            Take a look at how Antimetal can save time and money
          </div>
          <div className="section2-gred-container">
            <div>
              <div className="section2-gred-container-lable">
                SECTOR-SPECIFIC
              </div>
              <div className="section2-gred-container-heding">
                Lorem ipsum dolor sit amet, consecteturelit. Explicabo, error?
              </div>
              <div className="section2-gred-container-desc">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem,
                sunt!
              </div>
              <ul className="landing-section2-list">
                <li>
                  <div>
                    <FaCheck size={"0.75rem"} color="#151F43" />
                  </div>
                  <p>Lorem</p>
                </li>
                <li>
                  <div>
                    <FaCheck size={"0.75rem"} color="#151F43" />
                  </div>
                  <p>Lorem</p>
                </li>
                <li>
                  <div>
                    <FaCheck size={"0.75rem"} color="#151F43" />
                  </div>
                  <p>Lorem</p>
                </li>
                <li>
                  <div>
                    <FaCheck size={"0.75rem"} color="#151F43" />
                  </div>
                  <p>Lorem</p>
                </li>
              </ul>
            </div>
            <div>
              <img src={FormHeroImg} alt="" />
            </div>
          </div>
        </div>{" "}
        <div className="landing-grid-section-container">
          <div style={{ width: "3rem" }}>
            <div>
              <img src={LandingCube} alt="" />
            </div>
            <div className="landing-grid-sec-line"></div>
          </div>
          <div style={{ width: "100%" }}>
            <div className="landing-grid-section-container-title">
              Designed for <br /> multiplayer
            </div>
            <div className="landing-grid-section-container-desc">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              <br /> Incidunt, odio.
            </div>
            <div className="landing-grid-section-layoutcontainer">
              <div className="item-1">
                <p className="landing-grid-item-text">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Explicabo, eos.
                </p>
                <div>
                  <img
                    src={LandingGridImg1}
                    alt=""
                    style={{
                      width: "100%",
                      objectFit: "contain",
                      borderBottomRightRadius: "1rem",
                    }}
                  />
                </div>
              </div>
              <div className="item-2">
                <p className="landing-grid-item-text">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Explicabo, eos.
                </p>
                <div>
                  <img
                    src={LandingGridImg2}
                    alt=""
                    style={{ width: "100%", objectFit: "contain" }}
                  />
                </div>
              </div>
            </div>
            <div className="landing-grid-section-layoutcontainer">
              <div className="item-3">
                <p className="landing-grid-item-text">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Explicabo, eos.
                </p>
                <div>
                  <img
                    src={LandingGridImg3}
                    alt=""
                    style={{
                      width: "100%",
                      objectFit: "contain",
                      borderBottomLeftRadius: "1rem",
                    }}
                  />
                </div>
              </div>
              <div className="item-4">
                <p className="landing-grid-item-text">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Explicabo, eos.
                </p>
                <div>
                  <img
                    src={LandingGridImg4}
                    alt=""
                    style={{
                      width: "100%",
                      objectFit: "contain",
                      borderRadius: "0.5rem",
                    }}
                  />
                </div>
              </div>
            </div>
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  margin: "3rem 0rem",
                }}
              >
                <div style={{ width: "50px", height: "50px" }}>
                  <img
                    src="https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                    alt=""
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                  />
                </div>
                <p
                  style={{
                    textAlign: "center",
                    width: "60%",
                    color: "#5C5C5C",
                  }}
                >
                  Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                  Dolore, voluptate illo! Inventore autem dolores accusantium
                  tenetur, quam ad totam qui.
                </p>
              </div>
            </div>
          </div>
        </div>
        {}
        {/* testimonials */}
        <div style={{ marginTop: "3rem" }}>
          <div className="landing-section3-title">
            <span style={{ color: "#0056FF" }}>Every day, there are new</span>
            <br />
            success stories
          </div>
          <div className="landing-section3-text">
            Our community is building better habits, crushing
          </div>
          <div className="landing-testimonial">
            <div className="landing-testimonial-container">
              {testimonialData.map((item, i) => (
                <TestimonialCard key={i} item={item} />
              ))}
            </div>
          </div>
        </div>
        <div className="landing-banner-container">
          <div className="landing-banner-left">
            <div>
              Plan smarter, track
              <br />
              better, and stay in
              <br /> <span style={{ color: "#fff" }}>sync together.</span>
            </div>
          </div>
          <div className="landing-banner-right">
            <img src={BannerIllu} alt="" />
          </div>
        </div>
        <div className="landing-footer-container">
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              paddingBottom: "3rem",
            }}
          >
            <div
              style={{
                width: "30%",
                display: "flex",
                flexDirection: "column",
                rowGap: "3rem",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                {/* <img src={SLogo} alt="" /> */}
                <img src={StaciaTextLogo} alt="" />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  columnGap: "2.5rem",
                }}
              >
                <a
                  href="https://x.com/i/flow/login?redirect_after_login=%2FStaciaCorp%2Fwith_replies"
                  target="blank"
                >
                  <FaXTwitter size="1.4rem" color="6B7280" />
                </a>
                <a href="https://www.facebook.com/staciacorp/">
                  <FaLinkedinIn size="1.5rem" color="6B7280" />
                </a>
                <a href="https://www.instagram.com/stacia_corp_/?hl=en">
                  <FaInstagram size="1.5rem" color="6B7280" />
                </a>
              </div>
            </div>
            <div style={{ width: "40%", display: "flex" }}>
              <div style={{ width: "33%" }}>
                <div>Company</div>
                <ul>
                  <li>
                    <a href="https://staciacorp.com/about">About</a>
                  </li>
                  <li>
                    <a href="https://staciacorp.com/career">Careers</a>
                  </li>
                  {/* <li>
                    <a href="https://www.staciacorp.com">Contact</a>
                  </li> */}
                </ul>
              </div>
              <div style={{ width: "33%" }}>
                <div>Product</div>
                <ul>
                  <li>
                    <a href="https://staciacorp.com/products">Products</a>
                  </li>
                  <li>
                    <a href="https://staciacorp.com/services">Services</a>
                  </li>
                  <li>
                    <a href="https://staciacorp.com/project">Projects</a>
                  </li>
                </ul>
              </div>
              <div style={{ width: "33%" }}>
                <div>Resources</div>
                <ul>
                  <li>
                    <a href="https://staciacorp.com/case-study">Case Studies</a>
                  </li>
                  <li>
                    <a href="https://staciacorp.com/article">Articles</a>
                  </li>
                  {/* <li>
                    <a href="https://www.staciacorp.com">what's New</a>
                  </li> */}
                </ul>
              </div>
            </div>
            <div
              style={{
                width: "30%",
              }}
            >
              <div>Reach Us</div>
              <p style={{ marginTop: "0.75rem", color: "#6b7280" }}>
                Ground Floor, C-53, Guindy Industrial Estate,
                <br />
                Guindy, Chennai - 32, Tamil Nadu
              </p>
            </div>
          </div>
          <div
            style={{
              textAlign: "center",
              padding: "3rem",
              borderTop: "1px solid #F3F4F6",
              color: "#6b7280",
            }}
          >
            ©Copyright Stacia®Corp
          </div>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;

const TestimonialCard = ({ item }) => {
  return (
    <div>
      <div className="testimonial-card-head">
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <div style={{ width: "50px", height: "50px" }}>
            <img
              src="https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
              alt=""
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "50%",
              }}
            />
          </div>
          <div>
            <div>{item.name}</div>
            <div>{item.email}</div>
          </div>
        </div>
        <FaTwitter color="#8493B2" size={"1.5rem"} />
      </div>
      <p className="testimonial-card-desc">{item.desc}</p>
      <div>4:05 PM . Jan 9, 2023</div>
    </div>
  );
};
